import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useParams } from 'react-router-dom';
import './Manage_User.css';
//mport { BASE_URL } from "./Constants.js";
import useAuth from './useAuth';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';
import * as XLSX from 'xlsx';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const Loader = () => (
    <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
        </div>
        <p>Loading...</p>
    </div>
);

// function to correct date format 2025-02-25 12:32:08.000000 to 10-02-2025
function correctDateFormat(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [day, month, year].join('-');
}




function FuelForm() {

    useAuth();
    const [fueltypeData, setFueltypeData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [items, setItems] = useState([]);
    const [filteredItems, setFilteredItems] = useState([]);
    const [vehicleModals, setVehicleModals] = useState([]);
    const [vehicleTypes, setVehicleTypes] = useState([]);
    const [vehicleNumbers, setVehicleNumbers] = useState([]);
    const [vehicleMakes, setVehicleMakes] = useState([]);
    const [fuelTypes, setFuelTypes] = useState([]);
    const navigate = useNavigate();
    const token = localStorage.getItem("authToken") || null;
    const [fuelFormDetails, setFuelFormDetails] = useState([]);
    const [formData, setFormData] = useState({
        dated: '',
        emp_name: '',
        emp_code: '',
        emp_mobile: '',
        products: [],
    });
    //params id
    const { id } = useParams();


    // fetch vehicle modals
    const fetchVehicleModals = async (id) => {
        try {
            const response = await fetch(`${API_BASE_URL}getVehicleModels`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status) {
                setVehicleModals(result.data);
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError('Failed to fetch items');
        } finally {
            setLoading(false);
        }
    };

    // fetch vehicle types
    const fetchVehicleTypes = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}getVehicleTypes`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status) {
                setVehicleTypes(result.data);
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError('Failed to fetch items');
        } finally {
            setLoading(false);
        }
    };

    // fetch vehicle numbers
    const fetchVehicleNumbers = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}getVehicleNumbers`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status) {
                setVehicleNumbers(result.data);
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError('Failed to fetch items');
        } finally {
            setLoading(false);
        }
    };

    // fetch fuel types
    const fetchFuelTypes = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}getFuelTypes`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status) {
                setFuelTypes(result.data);
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError('Failed to fetch items');
        } finally {
            setLoading(false);
        }
    };

    // fetch vehicle makes
    const fetchVehicleMakes = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}getVehicleMakes`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status) {
                setVehicleMakes(result.data);
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError('Failed to fetch items');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchVehicleTypes();
        fetchVehicleModals();
        fetchVehicleNumbers();
        fetchFuelTypes();
        fetchVehicleMakes();
    }, [navigate]);

    //get fuel form details
    const fetchFuelFormDetails = async (id) => {
        try {
            const response = await fetch(`${API_BASE_URL}getFuelFormById/${id}`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            console.log('Fuel Form Details : ', result);
            if (result.status === true) {
                setFuelFormDetails(result.data);

                // Update form data for driver details
                setFormData({
                    dated: result.data.dated,
                    emp_name: result.data.emp_name,
                    emp_code: result.data.emp_code,
                    emp_mobile: result.data.emp_mobile,
                });
               
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError('Failed to fetch items');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchFuelFormDetails(id);
    }, [id]);

       // fetching products data
       const fetchProducts = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}getFuelFormContentById/${id}`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },

            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            console.log('Fuel Form Details : ', result);
            if (result.status === true) {
                setProducts(result.data);

            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError('Failed to fetch items');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProducts();
    }, []);

    
    // Initialize products state with one empty row
    const [products, setProducts] = useState([
        { fuel_form_id: id, dated: '', vehicle_number: '', vehicle_make: '', vehicle_modal: '', vehicle_type: '', fuel_type: '', fuel_unit: '',  rate: 0, quantity: 1 }
    ]);

    // Handle adding a new row
    const addProduct = () => {
        const newProduct = { id: Date.now(), fuel_form_id:id,  rate: 0, quantity: 1 };
        setProducts([...products, newProduct]);
    };

    // Handle deleting a row
    const deleteProduct = (id) => {
        setProducts(products.filter(product => product.id !== id));
    };

    // Handle updating product details
    const handleChange = (id, field, value) => {
        const updatedProducts = products.map(product =>
            product.id === id ? { ...product, [field]: value } : product
        );
        setProducts(updatedProducts);
    };

    // Calculate the total amount
    const calculateTotal = () => {
        return products.reduce((total, product) => total + (product.rate * product.quantity), 0);
    };

    // Calculate the total quantity
    const calculateTotalQuantity = () => {
        return products.reduce((total, product) => total + product.quantity, 0);
    };

  

    // Handle submitting the product data
    const handleSubmit = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}updateFuelFormContent/${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(products),
            });

            if (response.ok) {
                alert('Products submitted successfully!');
            } else {
                alert('Failed to submit products.');
            }
        } catch (error) {
            console.error('Error submitting products:', error);
        }
    };



    return (
        <div className="hold-transition sidebar-mini layout-fixed" style={{ fontSize: '12px' }}>
            <div className="wrapper">
                <Header />
                <Sidebar />
                <div className="content-wrapper">
                    <section className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className='m-0' style={{ fontSize: '20px' }}>Fuel Form</h1>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <section className="col-lg-12 ">
                                    <div className="card">

                                        <div className="card-body">

                                            {loading ? (
                                                <Loader />
                                            ) : (
                                                <>
                                                    <h6>Vehicle Driver Details</h6>
                                                    <div className='row' >

                                                        <div className='form-group col-md-3'>
                                                            <label className='mr-2'>Name</label>
                                                            <input type='text' value={formData.emp_name} className="w-full px-2 py-1 border rounded" name='emp_name' id='emp_name' />
                                                        </div>
                                                        <div className='form-group col-md-3'>
                                                            <label className='mr-2'>BMID</label>
                                                            <input type='text' value={formData.emp_code} className="w-full px-2 py-1 border rounded" name='emp_code' id='emp_code' />
                                                        </div>
                                                        <div className='form-group col-md-3'>
                                                            <label className='mr-2'>Mobile</label>
                                                            <input type='text' value={formData.emp_mobile} className="w-full px-2 py-1 border rounded" name='emp_mobile' id='emp_mobile' />
                                                        </div>
                                                        <h6>Datewise Fuel Details</h6>

                                                        <table className="table-auto w-full border-collapse border border-gray-400">
                                                            <thead>
                                                                <tr className="bg-gray-200">
                                                                    <th className="border"> </th>
                                                                    <th className="border px-4 py-2">Date</th>
                                                                    <th className="border px-4 py-2">Vehicle Number</th>
                                                                    <th className="border px-4 py-2">Type</th>
                                                                    <th className="border px-4 py-2">Make</th>
                                                                    <th className="border px-4 py-2">Modal</th>
                                                                    <th className="border px-4 py-2">Fuel</th>
                                                                    <th className="border px-4 py-2">Fuel Unit</th>
                                                                    <th className="border px-4 py-2">Fuel Rate</th>
                                                                    <th className="border px-4 py-2">Quantity</th>
                                                                    <th className="border px-4 py-2">Total</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {products.map((product) => (
                                                                    <tr key={product.id}>
                                                                        <td className="border px-2 py-1">
                                                                            <i onClick={() => deleteProduct(product.id)} className='fa fa-trash' style={{ color: 'red' }} ></i>
                                                                        </td>
                                                                        <td className="border px-2 py-1">
                                                                            <input
                                                                                required
                                                                                type="date"
                                                                                value={product.dated}
                                                                                onChange={(e) => handleChange(product.id, 'dated', e.target.value)}
                                                                                className="w-full px-2 py-1 border rounded"
                                                                            />
                                                                        </td>
                                                                        <td className="border px-2 py-1">
                                                                            <select 
                                                                             onChange={(e) => handleChange(product.id, 'vehicle_number', e.target.value)}
                                                                            className="w-full px-2 py-1 border rounded" name='vehicle_number_id' id='vehicle_number_id'>
                                                                                <option value=''>Vehicle Number</option>
                                                                                {vehicleNumbers.map((vehicleNumber) => (
                                                                                    <option key={vehicleNumber.id} value={vehicleNumber.vehicle_number}>
                                                                                        {vehicleNumber.vehicle_number}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        </td>
                                                                        <td className="border px-2 py-1">
                                                                            <select
                                                                             onChange={(e) => handleChange(product.id, 'vehicle_type', e.target.value)}
                                                                             className="w-full px-2 py-1 border rounded" name='vehicle_type' id='vehicle_type'>
                                                                                <option value=''> Type</option>
                                                                                {vehicleTypes.map((vehicleType) => (
                                                                                    <option key={vehicleType.id} value={vehicleType.vehicle_type}>
                                                                                        {vehicleType.vehicle_type}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        </td>
                                                                        <td className="border px-2 py-1">
                                                                            <select
                                                                            onChange={(e) => handleChange(product.id, 'vehicle_make', e.target.value)}
                                                                             className="w-full px-2 py-1 border rounded" name='vehicle_make' id='vehicle_make'>
                                                                                <option value=''>Make</option>
                                                                                {vehicleMakes.map((vehicleMake) => (
                                                                                    <option key={vehicleMake.id} value={vehicleMake.vehicle_make}>
                                                                                        {vehicleMake.vehicle_make}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        </td>
                                                                        <td className="border px-2 py-1">
                                                                            <select 
                                                                            onChange={(e) => handleChange(product.id, 'vehicle_modal', e.target.value)}
                                                                            className="w-full px-2 py-1 border rounded" name='vehicle_modal' id='vehicle_modal'>
                                                                                <option value=''>Modal</option>
                                                                                {vehicleModals.map((vehicleModal) => (
                                                                                    <option key={vehicleModal.id} value={vehicleModal.vehicle_modal}>
                                                                                        {vehicleModal.vehicle_modal}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        </td>
                                                                        <td className="border px-2 py-1">
                                                                            <select
                                                                            onChange={(e) => handleChange(product.id, 'fuel_type', e.target.value)} 
                                                                             className="w-full px-2 py-1 border rounded" name='fuel_type_id' id='fuel_type_id'>
                                                                                <option value=''>Fuel Type</option>
                                                                                {fuelTypes.map((fuelType) => (
                                                                                    <option key={fuelType.id} value={fuelType.fuel_type}>
                                                                                        {fuelType.fuel_type}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        </td>

                                                                        <td className="border px-2 py-1">
                                                                            <select 
                                                                            onChange={(e) => handleChange(product.id, 'fuel_unit', e.target.value)}
                                                                            className="w-full px-2 py-1 border rounded" name='fuel_unit' id='fuel_unit'>
                                                                                <option value=''>Fuel Unit</option>
                                                                                <option value='Litre'>Litre</option>
                                                                                <option value='Kg'>Kg</option>
                                                                            </select>

                                                                            {/* <input
                                                                    type="text"
                                                                    value={product.name}
                                                                    onChange={(e) => handleChange(product.id, 'name', e.target.value)}
                                                                    className="w-full px-2 py-1 border rounded"
                                                                /> */}
                                                                        </td>
                                                                        <td className="border px-4 py-2">
                                                                            <input
                                                                                type="number"
                                                                                value={product.rate}
                                                                                onChange={(e) => handleChange(product.id, 'rate', parseFloat(e.target.value))}
                                                                                className="w-full px-2 py-1 border rounded"
                                                                            />
                                                                        </td>
                                                                        <td className="border px-4 py-2">
                                                                            <input
                                                                                type="number"
                                                                                value={product.quantity}
                                                                                onChange={(e) => handleChange(product.id, 'quantity', parseInt(e.target.value))}
                                                                                className="w-full px-2 py-1 border rounded"
                                                                            />
                                                                        </td>
                                                                        <td className="border px-4 py-2"> {product.rate * product.quantity}</td>

                                                                    </tr>
                                                                ))}

                                                                <tr>
                                                                    <td className="border px-2 py-1">
                                                                        <i onClick={addProduct} className='fa fa-plus'></i>
                                                                    </td>
                                                                    <td colSpan="8" className="border px-4 py-2 text-right">
                                                                        <strong>Total Fuel Qty : {calculateTotalQuantity()} </strong>
                                                                    </td>
                                                                    <td colSpan="1" className="border px-4 py-2 text-right">
                                                                        <strong>Total </strong>
                                                                    </td>
                                                                    <td className="border px-4 py-2">  <strong>₹ {calculateTotal()}</strong>  </td>
                                                                </tr>


                                                            </tbody>
                                                        </table>

                                                        <div className="mt-4">
                                                            <button
                                                                onClick={handleSubmit}
                                                                style={{ backgroundColor: '#4CAF50', color: 'white' }}
                                                                className="px-4 py-2 rounded">
                                                                Save Draft
                                                            </button>
                                                        </div>

                                                    </div>

                                                </>
                                            )}
                                        </div>



                                    </div>
                                </section>
                            </div>
                        </div>
                    </section>
                </div>
                <Footer />
            </div>
        </div>
    )
}

export default FuelForm; 